// @eslint-disable

import React, { useState, useEffect, useRef } from 'react';
import { TOGGLE_CHAT_SCREEN } from '../../redux/reducers/chatScreenReducer';
import { useDispatch, useSelector } from 'react-redux';
import minimizeIcon from "../../assets/minimize.svg";
import tax1099Minimize from "../../assets/image/tax1099_mimimize.svg";
// import demoIcon from '../../assets/image/demo.svg';
// import calculatorIcon from '../../assets/image/calculator.svg';
import muteIcon from "../../assets/mute.svg";
import unMute from "../../assets/unMute.svg";
// import volume_up from "../../assets/volume_up.svg"
import support_agent from "../../assets/image/human-agent.jpeg"
import { TOGGLE_AUDIO_STATE } from '../../redux/reducers/audio';
import aiIcon from "../../assets/image/2290.ai_icon.svg";
// import HumanAgentTransfer from '../humanAgentTransfer/HumanAgentTransfer';
import useResponsive from '../../hooks/useResponsiveClass';
import { RootState } from '../../redux/store';
import socket from '../../socket';
import { isThrottled, setThrottle, getFormattedRemainingTime } from '../../utils/humanAgentThrottle';
// import { globalCards } from '../../utils/global.card';
// import { CardCombinedType } from '../../types/chat.types';
// import { ADD_EVENT } from '../../redux/reducers/eventReducer';

interface ChatHeaderProps {
  onClose?: () => void;
  selectedTab: string;
  onBackPress: () => void;
}
const colorFrom = process.env.REACT_APP_COLOR_FROM;
const colorTo = process.env.REACT_APP_COLOR_TO;
const clientType = process.env.REACT_APP_CLIENT;

const ChatHeader: React.FC<ChatHeaderProps> = ({
  selectedTab,
  onBackPress,
}) => {
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  const isMute = useSelector((state: RootState) => state.audio?.mute ?? false)
  const events = useSelector((state: RootState) => state.events);
  const dispatch = useDispatch();
  const roomId = localStorage.getItem('userNumber');
  const [showPopup, setShowPopup] = useState(false);
  const {isMobile} = useResponsive();
  const [isThrottledState, setIsThrottledState] = useState(false);
  const throttleTimerRef = useRef<NodeJS.Timeout | null>(null);
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  // const dropdownRef = useRef<HTMLDivElement>(null);

  // Check throttle status on mount and update every second
  useEffect(() => {
    const checkThrottle = () => {
      const throttled = isThrottled();
      setIsThrottledState(throttled);
    };

    // Initial check
    checkThrottle();
    
    // Check throttle every second to update the status
    throttleTimerRef.current = setInterval(checkThrottle, 1000);
    
    return () => {
      if (throttleTimerRef.current) {
        clearInterval(throttleTimerRef.current);
        throttleTimerRef.current = null;
      }
    };
  }, []);

  const toggleLoginPopover = () => {
    // Check if user is throttled
    if (isThrottled()) {
      const remainingTime = getFormattedRemainingTime();
      alert(`Already raised request. Please wait ${remainingTime} before creating another one.`);
      return;
    }
    
    const newShowPopupValue = !showPopup;
    
    // Emit socket event and set throttle when opening the human agent popup
    if (newShowPopupValue) {
      console.log('🤝 Emitting contact_live_agent event');
      socket.emit('sendchat', 'connect to a human agent', roomId);
      
      // Set throttle immediately when user clicks
      setThrottle();
      setIsThrottledState(true);
    }
    
    setShowPopup(newShowPopupValue);
  };

  const chatBotEvents =
    events &&
    events.length > 0 &&
    events.filter((event) => event.senderType === 'USER');

  const showHumanAgentIcon = chatBotEvents && chatBotEvents.length > 0;
  const toggleChat = () => {
    dispatch({
      type: TOGGLE_CHAT_SCREEN,
    });
  };

  // useEffect(() => {
  //   function handleClickOutside(event: MouseEvent) {
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(event.target as Node)
  //     ) {
  //       setDropdownOpen(false);
  //     }
  //   }
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, []);

//   const handleCardClick = (card: CardCombinedType) => {
//   const timeStamp = new Date().toISOString();
//   const divId = `card-${Math.random().toString(36).substr(2, 9)}`;

//   dispatch({
//     type: ADD_EVENT,
//     payload: {
//       ...card,
//       id: divId,
//       divId,
//       user: 'actionCard',
//       time: timeStamp,
//       senderType: 'chatBot',
//     },
//   });
// };


  // const handleOptionClick = (option: string) => {
  //   if (option === 'Calculator') {
  //     handleCardClick(globalCards['pricingCalculatorCard']);
  // } else if (option === 'Demo') {
  //   handleCardClick(globalCards['contactDemo']);
  // }
  //   setDropdownOpen(false);
  // };

  const toggleAudio = () => {
    dispatch({
      type: TOGGLE_AUDIO_STATE,
    })
  }

  const bgType = process.env.REACT_APP_CLIENT;
  const backgroundStyle = bgType === "salesbot2290ai"
    ? { backgroundImage: `linear-gradient(to right, ${colorFrom}, ${colorTo})` }
    : { backgroundImage: `linear-gradient(to bottom, ${colorFrom}, ${colorTo})` };

  return (
    <>
    <div 
      style={backgroundStyle}
      className={`relative flex flex-row py-1 px-2 h-16 text-white justify-between items-center ${isMobile ? "max-h-[15%]" : "max-h-[11%]"} border-b-[1px] border-grey-50 rounded-t-xl`}>
      {selectedTab === 'messages' && (
        <button className="text-white" onClick={onBackPress}>
          <svg
            className="w-4 h-4 order-first"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 8 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
            />
          </svg>
        </button>
      )}

      <div className="flex flex-col max-h-full">
        {/* <div className="h-[32px] w-[96px] ml-1">
          <img src={aiIcon} alt="Chat Bot" className="h-full w-full" />
        </div> */}
          <div className="h-[32px] w-[140px] ml-1">
            {clientType === 'salesbot2290ai' ? (
              <img src={aiIcon} alt="Chat Bot" className="h-full w-full" />
            ) : (
              <span className="flex items-end justify-start h-full w-full text-[#F9F9F9] text-[22px] font-semibold font-sans">
                {'Zenwork AI'}
              </span>
            )}
          </div>
          {clientType === 'salesbot2290ai' ? (
            <div className="text-[#F9F9F9] text-[14dpx] ml-4">
              Enhanced AI
            </div>
          ) : (
            <div className="text-[#F9F9F9] text-[14dpx] text-[12px] ml-1 italic">
              Your trusted partner, powered by intelligence
            </div>
          )}
        </div>
        <div className="mt-1 flex gap-4">
          {selectedTab !== 'messages' && (
          <>
            
            {(showHumanAgentIcon) && (
              <div className="relative flex">
                <button
                  className="mx-2"
                  onClick={toggleLoginPopover}
                  disabled={connectionStatus !== 'Connected' || isThrottledState}
                  title={isThrottledState ? 'Request already raised. Please wait.' : 'Connect with human agent'}
                >
                  <img
                    src={support_agent}
                    alt="Human Agent"
                    className={`order-first h-[20px] w-[20px] rounded-full block ${
                      isThrottledState || connectionStatus !== 'Connected' 
                        ? 'opacity-50 cursor-not-allowed' 
                        : 'cursor-pointer'
                    }`}
                  />
                </button>
              </div>
            )}
          </>
        )}
        <div className='h-[48px] w-[20px] flex justify-center items-center cursor-pointer' style={{ transition: 'transform 0.3s ease, opacity 0.3s ease' }} onClick={toggleAudio}>
          <img className='size-fit w-full transition-all duration-300 ease-in-out' src={isMute ? unMute : muteIcon} alt="audio icon" />
        </div>
        <div
          className="h-[48px] w-[20px] flex justify-center items-center cursor-pointer"
          onClick={toggleChat}
        >
          <img
            className="size-fit w-full filter contrast-[3.5]"
            src={clientType === 'salesbot2290ai' ? minimizeIcon : tax1099Minimize}
            alt="close icon"
          />
        </div>
      </div>
      {/* {showPopup && <HumanAgentTransfer setShowPopup={setShowPopup} />} */}
    </div>

      {/* <div
        ref={dropdownRef}
        className={`relative flex flex-row justify-end py-1 px-2 h-16 text-white bg-[#F9F9F9] ${
          isMobile ? 'max-h-[6%]' : 'max-h-[4%]'
        }`}
      >
        <div className="relative z-10">
          <button
            className="flex items-center gap-2 px-3 py-2 bg-white border border-[#EAECF0] rounded-md cursor-pointer text-[#383E49] font-lato text-[14px]"
            onClick={() => setDropdownOpen((prev) => !prev)}
            type="button"
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
          >
            More
            <img
              className={`w-6 h-5 filter contrast-[3.5] transition-transform duration-200`}
              src={minimizeIcon}
              alt="dropdown arrow"
            />
          </button>

          {dropdownOpen && (
            <ul className="absolute top-full right-0 mt-6 w-40 bg-white border-[1px] border-[#EAECF0] rounded-md shadow-md z-10">
              <li
                className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 cursor-pointer text-[#383E49] font-lato text-[14px]"
                onClick={() => handleOptionClick('Calculator')}
              >
                <img
                  src={calculatorIcon}
                  alt="Calculator Icon"
                  className="w-4 h-4"
                />
                Pricing Calculator
              </li>
              <li
                className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 cursor-pointer text-[#383E49] font-lato text-[14px]"
                onClick={() => handleOptionClick('Demo')}
              >
                <img src={demoIcon} alt="Demo Icon" className="w-4 h-4" />
                Book a Demo
              </li>
            </ul>
          )}
        </div>
      </div> */}
    </>
  );
};

export default ChatHeader;
